// 导入组件
import Vue from "vue";
import Router from "vue-router";
// 登录
import login from "@/views/login";
// 框架
import Layout from "@/views/index";
/**
 * 首页
 */
// 首页
import Home from "@/views/home";

// 启用路由
Vue.use(Router);
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export const constantRoutes = [
  {
    path: "/login",
    name: "登录",
    component: (resolve) => require(["@/views/login"], resolve),
    hidden: true,
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/index",
    name: "框架",
    hidden: false,
    component: Layout,
    iconCls: "el-icon-tickets",
    children: [
      {
        path: "/Home",
        name: "首页",
        meta: {
          title: "首页",
          requireAuth: true,
          icon: "el-icon-house",
        },
        component: (resolve) => require(["@/views/home"], resolve),
      },
    ],
  },
  {
    path: "/productCentre",
    name: "产品中心",
    hidden: false,
    component: Layout,
    meta: {
      requireAuth: true,
      title: "产品中心",
      icon: "el-icon-s-data",
    },
    children: [
      {
        path: "/productCentre/index",
        name: "productCentre",
        component: (resolve) =>
          require(["@/views/productCentre/index"], resolve),
        meta: {
          requireAuth: true,
          title: "产品中心",
          icon: "el-icon-s-management",
        },
      },
      {
        path: "/productCentre/insureSum",
        name: "insureSum",
        component: (resolve) =>
          require(["@/views/productCentre/insure-sum"], resolve),
        meta: {
          requireAuth: false,
          title: "保费试算",
        },
      },
      {
        path: "/productCentre/insure",
        name: "insure",
        component: (resolve) =>
          require(["@/views/productCentre/insure"], resolve),
        meta: {
          requireAuth: false,
          title: "信息填写",
        },
      },
      {
        path: "/productCentre/pay",
        name: "pay",
        component: (resolve) => require(["@/views/productCentre/pay"], resolve),
        meta: {
          requireAuth: false,
          title: "支付方式",
        },
      },
    ],
  },
  {
    path: "/orderCentre",
    name: "订单中心",
    hidden: false,
    component: Layout,
    meta: {
      requireAuth: true,
      title: "订单中心",
      icon: "el-icon-s-data",
    },
    children: [
      {
        path: "/orderCentre/index",
        name: "订单中心",
        component: (resolve) => require(["@/views/orderCentre/index"], resolve),
        meta: {
          requireAuth: true,
          title: "订单中心",
          icon: "el-icon-s-order",
        },
      },
      {
        path: "/orderCentre/detail",
        name: "detail",
        component: (resolve) =>
          require(["@/views/orderCentre/detail"], resolve),
        meta: {
          requireAuth: false,
          title: "订单详情",
        },
      },
    ],
  },
  {
    path: "/policyCentre",
    name: "保单中心",
    hidden: false,
    component: Layout,
    meta: {
      requireAuth: true,
      title: "保单中心",
      icon: "el-icon-s-cooperation",
    },
    children: [
      {
        path: "/policyCentre/index",
        name: "保单中心",
        component: (resolve) =>
          require(["@/views/policyCentre/index"], resolve),
        meta: {
          requireAuth: true,
          title: "保单中心",
          icon: "el-icon-s-cooperation",
        },
      },
      {
        path: "/policyCentre/detail",
        name: "policyDetail",
        component: (resolve) =>
          require(["@/views/policyCentre/detail"], resolve),
        meta: {
          requireAuth: false,
          title: "保单详情",
        },
      },
      {
        path: "/policyCentre/fillAllInfo",
        name: "fillAllInfo",
        component: (resolve) =>
          require(["@/views/policyCentre/fillAllInfo"], resolve),
        meta: {
          requireAuth: false,
          title: "填写保全信息",
        },
      },
    ],
  },
  // {
  //   path: "/allCentre",
  //   name: "保全中心",
  //   hidden: false,
  //   component: Layout,
  //   meta: {
  //     requireAuth: true,
  //     title: "保全中心",
  //     icon: "el-icon-s-management",
  //   },
  //   children: [
  //     {
  //       path: "/allCentre/index",
  //       name: "保全中心",
  //       component: (resolve) => require(["@/views/allCentre/index"], resolve),
  //       meta: {
  //         requireAuth: true,
  //         title: "保全中心",
  //         icon: "el-icon-s-management",
  //       },
  //     },
  //     {
  //       path: "/allCentre/detail",
  //       name: "allDetail",
  //       component: (resolve) => require(["@/views/allCentre/detail"], resolve),
  //       meta: {
  //         requireAuth: false,
  //         title: "批单详情",
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/SettlementCentre",
  //   name: "结算中心",
  //   hidden: false,
  //   component: Layout,
  //   meta: {
  //     requireAuth: true,
  //     title: "结算中心",
  //     icon: "el-icon-s-data",
  //   },
  //   children: [
  //     {
  //       path: "/SettlementCentre/index",
  //       name: "结算中心",
  //       component: (resolve) =>
  //         require(["@/views/SettlementCentre/index"], resolve),
  //       meta: {
  //         requireAuth: true,
  //         title: "结算中心",
  //         icon: "el-icon-s-shop",
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/continueCentre",
  //   name: "续保中心",
  //   hidden: false,
  //   component: Layout,
  //   meta: {
  //     requireAuth: true,
  //     title: "续保中心",
  //     icon: "el-icon-s-data",
  //   },
  //   children: [
  //     {
  //       path: "/continueCentre/index",
  //       name: "续保中心",
  //       component: (resolve) =>
  //         require(["@/views/continueCentre/index"], resolve),
  //       meta: {
  //         requireAuth: true,
  //         title: "续保中心",
  //         icon: "el-icon-s-claim",
  //       },
  //     },
  //   ],
  // },
  {
    path: "*",
    redirect: "/404",
    hidden: true,
  },
  {
    path: "/404",
    component: (resolve) => require(["@/components/error"], resolve),
    hidden: true,
  },
];

let routerInfo = {
  mode: "hash", // 去掉url中的#
  scrollBehavior: () => ({
    y: 0,
  }),
  routes: constantRoutes,
  base: "/",
};
// 导出路由
export default new Router(routerInfo);



// WEBPACK FOOTER //
// ./src/router/index.js